import { Button } from "components/ui/button";

interface CancelConfirmModalProps {
  regionalName: string;
  gerenteName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export function CancelConfirmModal({
  regionalName,
  gerenteName,
  onConfirm,
  onCancel,
  isLoading,
}: CancelConfirmModalProps) {
  return (
    <div className="p-4">
      <h3 className="mb-4 text-lg font-medium">Confirmar Cancelamento</h3>
      <p className="mb-6 text-sm text-gray-600">
        Tem certeza que deseja cancelar a substituição de{" "}
        <strong>{regionalName}</strong> por <strong>{gerenteName}</strong>? O
        acesso herdado do substituto deixa de valer em poucos minutos; por data
        de fim, o corte é imediato.
      </p>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onCancel} disabled={isLoading}>
          Voltar
        </Button>
        <Button
          variant="destructive"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? "Cancelando..." : "Cancelar vínculo"}
        </Button>
      </div>
    </div>
  );
}
